module.exports = __webpack_public_path__ + "img/starfull.2195ed5d.png";